module.exports = __webpack_public_path__ + "static/testimonial-2-8b58a9ab09e8ea4db168ac4e7564e950.png";